export const LogoMark = ({ size = 30, id = "au" }) => (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true">
        <defs>
            <linearGradient id={`${id}-g`} x1="4" y1="4" x2="28" y2="28" gradientUnits="userSpaceOnUse">
                <stop stopColor="#00F0FF" />
                <stop offset="1" stopColor="#00FF87" />
            </linearGradient>
        </defs>
        <path
            d="M16 2.6L27.2 9.05v13.9L16 29.4 4.8 22.95V9.05L16 2.6z"
            stroke={`url(#${id}-g)`}
            strokeWidth="1.5"
        />
        <path
            d="M10.6 21.6L16 9.8l5.4 11.8"
            stroke={`url(#${id}-g)`}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path d="M13.1 17.4h5.8" stroke="#F8FAFC" strokeWidth="2" strokeLinecap="round" />
        <circle cx="21.4" cy="21.6" r="1.9" fill="#00FF87" />
    </svg>
);

export const Logo = ({ id = "au" }) => (
    <span className="flex items-center gap-2.5">
        <LogoMark id={id} />
        <span className="font-display text-sm sm:text-base font-bold tracking-wide text-white">
            AUTHENA<span className="text-neon-cyan">.XYZ</span>
        </span>
    </span>
);